import { useEffect, useLayoutEffect } from "react";
import { pageIndicator } from "../apollo";
import { Footer } from "../components/footer";
import { TopBar } from "../components/topBar";
import { personalInfo } from "../constants/texts";

export const PersonalInfo = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });
  useEffect(() => {
    pageIndicator("개인정보취급방침");
  }, []);
  return (
    <div className="max-w-screen-break mx-auto h-full overflow-auto">
      <div className="sticky left-0 top-0 bg-white shadow">
        <TopBar
          arrow={true}
          arrowColor={"#B5C1D0"}
          exit={true}
          home={true}
          heading={true}
        />
      </div>
      <div className="px-4 pt-4 pb-10 bg-main">
        <div className="rounded-xl p-4 bg-white border-btnLightLine">
          <p className="text-darkFont font-bold text-sm">개인정보취급방침</p>
          <div className="pl-4 pt-4 list-disc text-sm whitespace-pre-wrap">
            {personalInfo}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
